<template>
    <div :class="wrapperClass" class="xxs:pt-6 lg:pt-2">
        <label class="block text-body-6 font-medium text-default-1 mb-3"> {{ label }} </label>

        <div v-if="!isEditing || isDisabled">
            <p v-if="modelValue" class="text-body-6 text-default-1"> {{ modelValue }} </p>
            <p v-else class="text-body-6 text-default-4"> {{ placeholder }}</p>
        </div>
        <slot/>
        <div v-if="isEditing" class="sm:col-span-3">
            <input
                :type="type"
                :readonly="readOnly"
                :value="modelValue"
                @input="$emit('update:modelValue', $event.target.value)"
                @focusin="$emit('focusin', $event)"
                class="block w-full max-w-lg h-10 text-body-6 font-normal text-default-1 rounded border focus:outline-none focus:ring-0"
                :placeholder="placeholder" :class="inputErrorClass"
            />
            <p class="text-body-7 font-medium mt-1" :class="errorMessageClass"> {{ hintText }}</p>
        </div>
    </div>

</template>
<script setup>
import {computed} from '@vue/reactivity';

const props = defineProps({
    type: {
        type: String,
        default: "text",
        validator: function (value) {
            return ["text", "number", "email"].indexOf(value) !== -1;
        },
    },
    placeholder: {
        type: String,
    },
    label: {
        type: String,
    },
    hintText: {
        type: String,
        default: null
    },
    hasError: {
        type: Boolean,
        default: false
    },
    fieldName: {
        type: String
    },
    isEditing: {
        type: Boolean
    },
    modelValue: {
        type: String,
        default: ''
    },
    isDisabled: {
        type: Boolean,
        default: false
    },
    readOnly: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['update:modelValue', 'focusin']);

const errorMessageClass = computed(() => ({
    'text-interactive-3': props.hasError,
    'text-gray-500': !props.hasError
}));

const inputErrorClass = computed(() => ({
    'border-interactive-3 focus:border-interactive-3 hover:border-interactive-3': props.hasError,
    'border-interactive-9 focus:border-primary-1 hover:border-primary-1': !props.hasError
}));

const wrapperClass = computed(() => ({
    'sm:border-t sm:border-interactive-9': !props.isEditing
}));

</script>
